export interface IMergeItem {
    id: string;
    name: string;
    hasPhoto: boolean;
    type: EMergeType;
}

export enum EMergeType {
    author = 1,
    publisher,
    book
}